export const translations = {
  pl: {
    nav: {
      home: 'Strona główna',
      catalog: 'Katalog roślin',
      gallery: 'Galeria',
      cart: 'Koszyk',
    },
    home: {
      hero: {
        badge: '20 lat doświadczenia w uprawie roślin',
        title: {
          line1: 'Odkryj magię',
          line2: 'naszej szkółki'
        },
        subtitle: 'Tworzymy zielone przestrzenie z pasją i dbałością o każdy szczegół. Nasze rośliny to gwarancja jakości i piękna Twojego ogrodu.',
        catalogButton: 'Zobacz katalog',
        callButton: 'Zadzwoń do nas'
      },
      features: {
        plants: {
          title: 'Bogaty wybór roślin',
          description: 'Oferujemy szeroki asortyment drzew i krzewów w różnych rozmiarach'
        },
        transport: {
          title: 'Transport',
          description: 'Dowozimy rośliny pod wskazany adres'
        },
        design: {
          title: 'Projektowanie ogrodów',
          description: 'Kompleksowe usługi projektowania i zakładania ogrodów'
        },
        advice: {
          title: 'Doradztwo',
          description: 'Profesjonalne porady ogrodnicze'
        }
      },
      about: {
        title: 'O naszej szkółce',
        description: [
          'Szkółka drzew i krzewów ozdobnych Iglak Mierzejewski to rodzinna firma z 20-letnim doświadczeniem. Specjalizujemy się w uprawie wysokiej jakości roślin ozdobnych na terenie województwa mazowieckiego.',
          'Oferujemy szeroki wybór drzew i krzewów o różnych wysokościach, dostępnych zarówno w gruncie, jak i w doniczkach. Prowadzimy sprzedaż hurtową i detaliczną, zapewniając transport na terenie całej Polski.',
          'Nasze usługi obejmują nie tylko sprzedaż roślin, ale także kompleksowe projektowanie ogrodów, profesjonalne doradztwo oraz usługi sadzenia. W okresie świątecznym prowadzimy również sprzedaż choinek ciętych i w doniczkach.'
        ]
      }
    },
    footer: {
      contact: 'Kontakt',
      openingHours: {
        title: 'Godziny otwarcia',
        weekdays: 'Poniedziałek - Piątek: 7:00 - 19:00',
        saturday: 'Sobota: 7:00 - 18:00',
        sunday: 'Niedziela: 8:00 - 16:00'
      },
      location: 'Lokalizacja',
      rights: 'Wszelkie prawa zastrzeżone'
    },
    catalog: {
      title: 'Katalog roślin',
      sortBy: 'Sortuj według:',
      popularity: 'Popularności',
      alphabetically: 'Alfabetycznie',
      showDescription: 'Pokaż opis',
      hideDescription: 'Ukryj opis',
      availableSizes: 'Dostępne rozmiary:',
      expandAll: 'Rozwiń wszystkie',
      collapse: 'Zwiń',
      height: 'Wysokość',
      inStock: 'Dostępne',
      pieces: 'sztuk',
      fetchError: 'Wystąpił błąd podczas pobierania danych. Spróbuj odświeżyć stronę.',
      priceMode: 'Cennik',
      wholesale: 'Hurtowy',
      retail: 'Detaliczny',
      wholesaleInfo: 'Zamówienie hurtowe - minimum 2 000 zł',
      addToCart: 'Dodaj do koszyka',
      quantity: 'Ilość',
      cartModeConflict: 'Masz produkty w koszyku z innego cennika. Opróżnij koszyk, aby zmienić cennik.',
      cartCleared: 'Koszyk został opróżniony',
      clearCartToSwitch: 'Opróżnij koszyk, aby zmienić cennik',
    },
    checkout: {
      title: 'Koszyk i zamówienie',
      cartItems: 'Produkty w koszyku',
      emptyCart: 'Koszyk jest pusty',
      emptyCartTitle: 'Twój koszyk jest pusty',
      emptyCartMessage: 'Dodaj rośliny do koszyka, aby złożyć zamówienie',
      browseCatalog: 'Przejdź do katalogu',
      contactInfo: 'Dane kontaktowe',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      email: 'E-mail',
      phone: 'Telefon',
      vatNumber: 'NIP (opcjonalnie)',
      vatNumberPlaceholder: 'Podaj NIP dla faktury',
      pickupInPerson: 'Odbiór osobisty',
      pickupAddress: 'Adres odbioru:',
      deliveryAddress: 'Adres dostawy',
      deliverySection: 'Dostawa',
      europeDeliveryInfo: 'Realizujemy dostawy na terenie całej Europy',
      addressPlaceholder: 'Wpisz pełny adres dostawy (ulica, miasto, kod pocztowy)',
      calculatingDistance: 'Obliczanie odległości...',
      estimatedDistance: 'Szacowana odległość',
      geocodeError: 'Nie udało się rozpoznać adresu. Podaj odległość ręcznie.',
      manualDistance: 'Odległość w km (ręcznie)',
      free: 'Gratis',
      vatIncluded: 'Ceny brutto (zawierają VAT 8%)',
      acceptTermsRequired: 'Musisz zaakceptować regulamin',
      termsLabel: 'Akceptuję',
      termsLink: 'Regulamin sklepu',
      termsAnd: 'oraz',
      privacyLink: 'Politykę prywatności',
      transportCostInfo: 'Koszt transportu: 5 zł za kilometr',
      requiresPlanting: 'Usługa sadzenia',
      plantingCostInfo: 'Koszt sadzenia: 30 zł za drzewo (+ transport)',
      deliveryDate: 'Data dostawy/odbioru',
      additionalInfo: 'Dodatkowe informacje',
      additionalInfoPlaceholder: 'Dodatkowe uwagi do zamówienia',
      orderSummary: 'Podsumowanie zamówienia',
      subtotal: 'Wartość produktów',
      transport: 'Transport',
      planting: 'Sadzenie',
      trees: 'drzew',
      total: 'Razem do zapłaty',
      wholesaleInfo: 'Zamówienie hurtowe - minimum 2 000 zł',
      wholesaleMinimumWarning: 'Wartość zamówienia hurtowego musi wynosić minimum 2 000 zł',
      wholesaleMinimumError: 'Minimalna wartość zamówienia hurtowego to 2 000 zł',
      distanceRequired: 'Podaj odległość transportu',
      proceedToPayment: 'Przejdź do płatności',
      processing: 'Przetwarzanie...',
      orderSuccess: 'Zamówienie zostało złożone!',
      orderError: 'Wystąpił błąd podczas składania zamówienia',
    },
    success: {
      title: 'Dziękujemy za zamówienie!',
      message: 'Twoje zamówienie zostało opłacone i przyjęte do realizacji.',
      orderNumber: 'Numer zamówienia',
      backToHome: 'Wróć do strony głównej',
    },
    gallery: {
      title: 'Galeria',
      viewAll: 'Zobacz wszystkie zdjęcia'
    },
    legal: {
      termsTitle: 'Regulamin sklepu internetowego',
      privacyTitle: 'Polityka prywatności',
      termsFooter: 'Regulamin',
      privacyFooter: 'Polityka prywatności',
    },
  },
  en: {
    nav: {
      home: 'Home',
      catalog: 'Plant Catalog',
      gallery: 'Gallery',
      cart: 'Cart',
    },
    home: {
      hero: {
        badge: '20 years of experience in plant cultivation',
        title: {
          line1: 'Discover the magic',
          line2: 'of our nursery'
        },
        subtitle: 'We create green spaces with passion and attention to detail. Our plants guarantee quality and beauty for your garden.',
        catalogButton: 'View catalog',
        callButton: 'Call us'
      },
      features: {
        plants: {
          title: 'Wide Plant Selection',
          description: 'We offer a broad range of trees and shrubs in various sizes'
        },
        transport: {
          title: 'Transport',
          description: 'We deliver plants to your specified address'
        },
        design: {
          title: 'Garden Design',
          description: 'Comprehensive garden design and landscaping services'
        },
        advice: {
          title: 'Consulting',
          description: 'Professional gardening advice'
        }
      },
      about: {
        title: 'About Our Nursery',
        description: [
          'Iglak Mierzejewski tree and ornamental shrub nursery is a family business with 20 years of experience. We specialize in growing high-quality ornamental plants in the Mazowieckie region.',
          'We offer a wide selection of trees and shrubs of various heights, available both in-ground and in containers. We conduct wholesale and retail sales, providing transport throughout Poland.',
          'Our services include not only plant sales but also comprehensive garden design, professional consulting, and planting services. During the holiday season, we also sell cut and potted Christmas trees.'
        ]
      }
    },
    footer: {
      contact: 'Contact',
      openingHours: {
        title: 'Opening Hours',
        weekdays: 'Monday - Friday: 7:00 AM - 7:00 PM',
        saturday: 'Saturday: 7:00 AM - 6:00 PM',
        sunday: 'Sunday: 8:00 AM - 4:00 PM'
      },
      location: 'Location',
      rights: 'All rights reserved'
    },
    catalog: {
      title: 'Plant Catalog',
      sortBy: 'Sort by:',
      popularity: 'Popularity',
      alphabetically: 'Alphabetically',
      showDescription: 'Show description',
      hideDescription: 'Hide description',
      availableSizes: 'Available sizes:',
      expandAll: 'Expand all',
      collapse: 'Collapse',
      height: 'Height',
      inStock: 'Available',
      pieces: 'pcs',
      fetchError: 'An error occurred while fetching data. Please try refreshing the page.',
      priceMode: 'Price List',
      wholesale: 'Wholesale',
      retail: 'Retail',
      wholesaleInfo: 'Wholesale order - minimum 2,000 PLN',
      addToCart: 'Add to Cart',
      quantity: 'Quantity',
      cartModeConflict: 'You have items in your cart from a different price list. Clear your cart to switch.',
      cartCleared: 'Cart has been cleared',
      clearCartToSwitch: 'Clear cart to switch price list',
    },
    checkout: {
      title: 'Cart and Order',
      cartItems: 'Cart Items',
      emptyCart: 'Cart is empty',
      emptyCartTitle: 'Your cart is empty',
      emptyCartMessage: 'Add plants to your cart to place an order',
      browseCatalog: 'Browse catalog',
      contactInfo: 'Contact Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'E-mail',
      phone: 'Phone',
      vatNumber: 'VAT Number (optional)',
      vatNumberPlaceholder: 'Enter VAT number for invoice',
      pickupInPerson: 'Pick up in person (free transport)',
      pickupAddress: 'Pickup address:',
      deliveryAddress: 'Delivery Address',
      deliverySection: 'Delivery',
      europeDeliveryInfo: 'We deliver throughout Europe',
      addressPlaceholder: 'Enter full delivery address (street, city, postal code)',
      calculatingDistance: 'Calculating distance...',
      estimatedDistance: 'Estimated distance',
      geocodeError: 'Could not recognize the address. Please enter distance manually.',
      manualDistance: 'Distance in km (manual)',
      free: 'Free',
      vatIncluded: 'Gross prices (including 8% VAT)',
      acceptTermsRequired: 'You must accept the terms and conditions',
      termsLabel: 'I accept the',
      termsLink: 'Terms and Conditions',
      termsAnd: 'and',
      privacyLink: 'Privacy Policy',
      transportCostInfo: 'Transport cost: 5 PLN per kilometer',
      requiresPlanting: 'Planting service',
      plantingCostInfo: 'Planting cost: 30 PLN per tree (+ transport)',
      deliveryDate: 'Delivery/pickup date',
      additionalInfo: 'Additional Information',
      additionalInfoPlaceholder: 'Additional notes for your order',
      orderSummary: 'Order Summary',
      subtotal: 'Products Value',
      transport: 'Transport',
      planting: 'Planting',
      trees: 'trees',
      total: 'Total',
      wholesaleInfo: 'Wholesale order - minimum 2,000 PLN',
      wholesaleMinimumWarning: 'Wholesale order value must be at least 2,000 PLN',
      wholesaleMinimumError: 'Minimum wholesale order value is 2,000 PLN',
      distanceRequired: 'Please provide transport distance',
      proceedToPayment: 'Proceed to Payment',
      processing: 'Processing...',
      orderSuccess: 'Order has been placed!',
      orderError: 'An error occurred while placing the order',
    },
    success: {
      title: 'Thank you for your order!',
      message: 'Your order has been paid and accepted for processing.',
      orderNumber: 'Order number',
      backToHome: 'Back to home',
    },
    gallery: {
      title: 'Gallery',
      viewAll: 'View all photos'
    },
    legal: {
      termsTitle: 'Terms and Conditions',
      privacyTitle: 'Privacy Policy',
      termsFooter: 'Terms',
      privacyFooter: 'Privacy Policy',
    },
  }
};
